"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiChatMessage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
const chat_helpers_1 = require("@/components/domains/chat/chat.helpers");
const utils_1 = require("@/utils");
require("@/components/common");
let AiChatMessage = class AiChatMessage extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.datetime = '';
        this.hiddenReactions = false;
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
      ${(0, chat_helpers_1.renderChatMessageTime)(this.datetime)} ${this.renderReactions()}
    `;
    }
    renderReactions() {
        if (this.hiddenReactions)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-button-group>
        <mm-icon-button
          size="small"
          variant="ghost"
          icon=${common_1.ICON_NAMES.COPY}
          aria-label="복사"
          @click=${() => this.emitReaction('copy')}
        ></mm-icon-button>
        <mm-icon-button
          size="small"
          variant="ghost"
          icon=${common_1.ICON_NAMES.THUMBS_UP}
          aria-label="좋아요"
          @click=${() => this.emitReaction('like')}
        ></mm-icon-button>
        <mm-icon-button
          size="small"
          variant="ghost"
          icon=${common_1.ICON_NAMES.DISLIKE}
          aria-label="싫어요"
          @click=${() => this.emitReaction('dislike')}
        ></mm-icon-button>
      </mm-button-group>
    `;
    }
    emitReaction(reaction) {
        (0, utils_1.emit)(this, 'chat-reaction', { reaction });
    }
};
AiChatMessage.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }

    ::slotted(mm-ai-chat-bubble) {
      align-self: flex-start;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AiChatMessage.prototype, "datetime", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, attribute: 'hidden-reactions' })
], AiChatMessage.prototype, "hiddenReactions", void 0);
AiChatMessage = __decorate([
    (0, decorators_js_1.customElement)('mm-ai-chat-message')
], AiChatMessage);
exports.AiChatMessage = AiChatMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWktY2hhdC1tZXNzYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYWktY2hhdC1tZXNzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFFM0QsZ0RBQWdEO0FBQ2hELHlFQUE4RTtBQUM5RSxtQ0FBOEI7QUFFOUIsK0JBQTRCO0FBR3JCLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxnQkFBVTtJQUF0Qzs7UUFZdUIsYUFBUSxHQUFHLEVBQUUsQ0FBQTtRQUNtQixvQkFBZSxHQUFHLEtBQUssQ0FBQTtJQTBDckYsQ0FBQztJQXhDQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7UUFFUCxJQUFBLG9DQUFxQixFQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxJQUFJLENBQUMsZUFBZSxFQUFFO0tBQ2pFLENBQUE7SUFDSCxDQUFDO0lBRU8sZUFBZTtRQUNyQixJQUFJLElBQUksQ0FBQyxlQUFlO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFeEMsT0FBTyxJQUFBLFVBQUksRUFBQTs7Ozs7aUJBS0UsbUJBQVUsQ0FBQyxJQUFJOzttQkFFYixHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sQ0FBQzs7Ozs7aUJBS2pDLG1CQUFVLENBQUMsU0FBUzs7bUJBRWxCLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDOzs7OztpQkFLakMsbUJBQVUsQ0FBQyxPQUFPOzttQkFFaEIsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUM7OztLQUdoRCxDQUFBO0lBQ0gsQ0FBQztJQUVPLFlBQVksQ0FBQyxRQUFnQjtRQUNuQyxJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsZUFBZSxFQUFFLEVBQUUsUUFBUSxFQUFFLENBQUMsQ0FBQTtJQUMzQyxDQUFDOztBQXJETSxvQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7O0dBVWxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOytDQUFjO0FBQ21CO0lBQTNELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsU0FBUyxFQUFFLGtCQUFrQixFQUFFLENBQUM7c0RBQXdCO0FBYnhFLGFBQWE7SUFEekIsSUFBQSw2QkFBYSxFQUFDLG9CQUFvQixDQUFDO0dBQ3ZCLGFBQWEsQ0F1RHpCO0FBdkRZLHNDQUFhIn0=